import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const coverageRateApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'coverageRateApi',
  tagTypes: ['CoverageRate'],
  endpoints: () => ({})
})

export default coverageRateApi
